import FeatureFlagsHelper from '../featureFlags/featureFlagsHelper';
import config from '../../config';

class Logger {
  isLogInfoEnabled = true;
  isLogWarningEnabled = true;
  isLogErrorEnabled = true;

  isShowProdBrowserLogs = false;
  isConfigLoaded = false;

  constructor() {
    // Init default configuration
    this.isLogInfoEnabled = false;
    this.isLogWarningEnabled = true;
    this.isLogErrorEnabled = true;

    //  Skip browser logging if on production environment
    if (config.isBrowser && config.env === 'production') {
      this.isLogInfoEnabled = false;
      this.isLogWarningEnabled = false;
      this.isLogErrorEnabled = false;
    }
  }

  loadLogConfig() {
    if (this.isConfigLoaded) {
      return;
    }

    // Read config from feature flags
    this.isLogInfoEnabled = FeatureFlagsHelper.isActive('Toggle_DEV_InfoLogs');
    this.isShowProdBrowserLogs = FeatureFlagsHelper.isActive(
      'Toggle_DEV_ProdBrowserLogs',
    );

    this.isConfigLoaded = true;
  }

  logInfo(source: string, message: string, extra?: unknown) {
    this.loadLogConfig();
    if (this.isLogInfoEnabled) {
      this.log('INFO', source, message, extra);
    }
  }

  logWarning(source: string, message: string, extra?: unknown) {
    this.loadLogConfig();
    if (this.isLogWarningEnabled) {
      this.log('WARNING', source, message, extra);
    }
  }

  logError(source: string, message: string, extra?: unknown) {
    this.loadLogConfig();
    if (this.isLogErrorEnabled) {
      this.log('ERROR', source, message, extra);
    }
  }

  private log(level: string, source: string, message: string, extra?: unknown) {
    //  Skip browser logging if on production environment
    if (
      config.isBrowser &&
      config.env === 'production' &&
      !this.isShowProdBrowserLogs
    ) {
      return;
    }

    if (extra) {
      console.log(`[${level}][${source}] ${message}`, extra);
    } else {
      console.log(`[${level}][${source}] ${message}`);
    }
  }
}

export default new Logger();
